export const getSearchMatches = (contentString, queryString) => {
  // Escape all regex characters and remove trailing whitespace to prevent errors
  const transformedQueryStringParts = queryString
    .trim()
    .replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&')
    .split(/\s+/);
  return transformedQueryStringParts.every(part => contentString.match(new RegExp(part, 'i')));
};
